import { timerTelemetry as coreEventsTimerTelemtry } from 'core-events';
import { getContentClassByContentType, SearchFilterContentTypes } from 'search-gateway-client';
import { fetchTypeahead as internalFetchTypeahead } from 'stockblocks-client';
import { TypeaheadData } from 'stockblocks-client/src/typeahead/TypeaheadData';

const fetchTypeahead = async (
    contentType: SearchFilterContentTypes,
    query = '',
    typeaheadEnhancementExperiment = false,
    timerTelemetry: () => Promise<void> = () => coreEventsTimerTelemtry('search.frontEnd.typeAhead'),
): Promise<TypeaheadData | undefined> => {
    const typeaheadTimer = timerTelemetry;
    const contentClass = getContentClassByContentType(contentType);
    const mappedContentClass = contentClass === 'image' ? 'images' : contentClass;
    const data = await internalFetchTypeahead(mappedContentClass, encodeURIComponent(query));
    void typeaheadTimer();

    if (typeaheadEnhancementExperiment || data?.keywords?.length) {
        return data;
    }
};

export default fetchTypeahead;
